export default "/react/logoMarkviz-35cf1524.png";